import { SparklineIntervalTimeUnitEnum } from 'generated/graphql'

/**
 * Picks a sparkline bucket size from a date range length, so the chart shows a readable
 * number of points instead of one per day on long ranges. Thresholds are exclusive lower
 * bounds for the next-coarser bucket (e.g. 364 days still buckets by month, 365 switches to
 * quarter), not calendar boundaries.
 */
export function getCustomTimeUnitInterval(days: number) {
  if (days > 364) {
    return 'quarter'
  }

  if (days > 30) {
    return 'month'
  }

  if (days > 14) {
    return 'week'
  }

  return 'day'
}

const TIME_UNIT_MAP: Record<string, SparklineIntervalTimeUnitEnum> = {
  day: SparklineIntervalTimeUnitEnum.Day,
  week: SparklineIntervalTimeUnitEnum.Week,
  month: SparklineIntervalTimeUnitEnum.Month,
  quarter: SparklineIntervalTimeUnitEnum.Quarter,
}

export const convertTimeUnit = (unit: string): SparklineIntervalTimeUnitEnum =>
  TIME_UNIT_MAP[unit] ?? SparklineIntervalTimeUnitEnum.Week
